// extracted by mini-css-extract-plugin
export default {"item":"Waiting_item__Pqdnk","item-wp":"Waiting_item-wp__6UO+F"};